module.exports = __webpack_public_path__ + "static/media/bird-meadowlark1.1fe8b3f2.aac";